module.exports = __webpack_public_path__ + "img/product-4.e0e0d989.png";